import { render, staticRenderFns } from "./UserDashboardPets.vue?vue&type=template&id=bacc9404&scoped=true&"
import script from "./UserDashboardPets.vue?vue&type=script&lang=js&"
export * from "./UserDashboardPets.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardPets.vue?vue&type=style&index=0&id=bacc9404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacc9404",
  null
  
)

export default component.exports